import React from 'react'

export const TriangleGrid = () => {
    return <></>
}
